import http from "../../http-common";

export default class EventCategory {
  getEventCategory() {
    let url = `/events/category`;

    return http.get(url);
  }
}